import { render, staticRenderFns } from "./SiteShell.vue?vue&type=template&id=752a1d66&scoped=true"
import script from "./SiteShell.vue?vue&type=script&lang=js"
export * from "./SiteShell.vue?vue&type=script&lang=js"
import style0 from "./SiteShell.vue?vue&type=style&index=0&id=752a1d66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a1d66",
  null
  
)

export default component.exports